export default __webpack_public_path__ + "images/ddf998cd0ed2aa5ecc11444070f55cd2-melbourne_desktop.webp";